import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const env_factor = apiUrl + "/env_factor";
const routes = {
  label: "EnvFactor",
  root: env_factor,
  get_by_process_ids: env_factor + "/get_by_process_ids",
  delete: env_factor + "/delete",
  save: env_factor + "/save",
  get_materials_by_product_id: env_factor + "/get_materials_by_product_id",
  get_materials_by_project_id: env_factor + "/get_materials_by_project_id",
  get_materials_by_building_id: env_factor + "/get_materials_by_building_id",
  ai: env_factor + "/ai",
};

export const EnvFactor = {
  get_by_process_ids: (process_ids) => postWithToken(routes.get_by_process_ids, { process_ids }),
  /**
   *
   * @param {[{id:string, process_id:string, biogenic_gwp_total: number|null,  biogenic_gwp: number|null,
   * category: string|null, sub_category: string|null, default_gwp: number|null, default_unit: string|null,
   * description: string|null, factor: number|null, gwp_total: number|null, gwp_unit: string|null, quantity: number|null,
   * type: string|null, uncertainty: number|null, unit: string|null, density: number|null, length_unit: string|null,
   * length: number|null, width_unit: string|null, width: number|null, thickness_unit: string|null, thickness: number|null,
   * part_number: string|null, note: string|null, raw_material_id: string|null, project_reference_id: string|null }]} env_factors
   * @returns
   */
  save: (env_factors) => postWithToken(routes.save, env_factors),
  delete: (ids) => postWithToken(routes.delete, { ids }),
  get_materials_by_project_id: (project_id) => postWithToken(routes.get_materials_by_project_id, { project_id }),
  get_materials_by_product_id: (product_id) => postWithToken(routes.get_materials_by_product_id, { product_id }),
  get_materials_by_building_id: (building_id) => postWithToken(routes.get_materials_by_building_id, { building_id }),
  ai: (data) => postWithToken(routes.ai, data),
};
